import { render, staticRenderFns } from "./modalEmployeeDocument.vue?vue&type=template&id=6279b618&"
import script from "./modalEmployeeDocument.vue?vue&type=script&lang=js&"
export * from "./modalEmployeeDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports